import httpClient from "../utils/httpClient";

export const CheckLogin = async (loginRequest) => {
    const response = await httpClient.post(`/User/login`, loginRequest);
    return response.data;
};

export const generateRedirectLogin = async () => {
    const response = await httpClient.post(
        '/User/GenerateRedirectLogin'
    );
    return response.data;
};

export const consumeRedirectLogin = async (token) => {
    const response = await httpClient.post(
        "/User/ConsumeRedirectLogin",
        token,
        { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
};

export const sessionValidationCheck = async () => {
    const response = await httpClient.post(
        `/User/sessionValidationCheck`,
        {},
        {
            skipSessionCheck: true  
        }
    );

    return response.data;
};